import { ReactNode } from 'react';
import styles from './Section.module.scss';

interface SectionProps {
  children: ReactNode;
  id?: string;
  className?: string;
  padding?: 'sm' | 'md' | 'lg' | 'xl';
  background?: 'white' | 'gray' | 'primary' | 'transparent';
}

export function Section({
  children,
  id,
  className = '',
  padding = 'md',
  background = 'transparent',
}: SectionProps) {
  return (
    <section
      id={id}
      className={`${styles.section} ${styles[padding]} ${styles[background]} ${className}`}
    >
      {children}
    </section>
  );
}
